import { render, staticRenderFns } from "./ComplexWrite01.vue?vue&type=template&id=4b4fdd3c&scoped=true"
import script from "./ComplexWrite01.vue?vue&type=script&lang=js"
export * from "./ComplexWrite01.vue?vue&type=script&lang=js"
import style0 from "./ComplexWrite01.vue?vue&type=style&index=0&id=4b4fdd3c&prod&scoped=true&lang=scss"
import style1 from "./ComplexWrite01.vue?vue&type=style&index=1&id=4b4fdd3c&prod&scoped=true&lang=scss"
import style2 from "./ComplexWrite01.vue?vue&type=style&index=2&id=4b4fdd3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4fdd3c",
  null
  
)

export default component.exports